import React from 'react'
import { withRouter } from 'react-router-dom'
const title = {
    '/': 'User Details',
    '/user_details': 'User Details',
    '/file_upload': 'File Upload',
    '/header_mapping': 'Header Mapping',
    '/uniqueLocation': 'Unique Location',
    '/multiLocation': 'Multiple Location',
    '/spellCorrectionLocation': 'Spell Correction Location',
    '/manualLocation': 'Manual Location',
    '/directMatchVendor': 'Direct Match Vendor',
    '/spellCorrectionVendor': 'Spell Correction Vendor',
    '/directMatchTruck': 'Direct Match Truck',
    '/spellCorrectionTruck': 'Spell Correction Truck',
    '/FinalConsolidation': 'Final Consolidation',
    '/summaryScreen': 'Summary Screen',
    '/review-screen': 'Review Screen',
    '/dataUploadSection': 'Data Upload'
}


const HeaderTitle = ({ props }) => {
    if (props.history.location.pathname === '/summaryScreen' || props.history.location.pathname === '/dataUploadSection' || props.history.location.pathname === '/user_details' || props.history.location.pathname === '/') {
        return (
            <h4>
                {
                   `${ title[props.history.location.pathname]} : Metadata`
                }
            </h4>
        )
    }
    else if (props.history.location.pathname === '/review-screen') {
        return (
            <h4>
                {
                    `${title[props.history.location.pathname]}: (Dataset: ${sessionStorage.getItem('review-dataset')})`
                }
            </h4>
        )
    }
    else {
        return (
            <h4>
                {
                    `${title[props.history.location.pathname]} (Dataset ID: ${localStorage.getItem('dataset_id')})`
                }
            </h4>
        )
    }
}

const AppHeader = (props) => {

    return (
        <div>
            <div style={{ padding: '1% 0%' }} align="center" className="jumbotron row">
                <div className="col-12">
                    <HeaderTitle props={props} />
                </div>
            </div>
        </div>
    )
}

export default withRouter(AppHeader)
